import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Widget from '../../widget';
import { getProgress } from '../helpers';
import Style from './style';
import Label from '../../../../components/EllipsisText';

export const ProgressBar = ({ progress }) => {
  return (
    <div className="progress-cont">
      <div className="progress-bar">
        <div style={{ height: '100%', width: `${progress}%`, background: progress === 100 ? '#52C41A' : 'var(--mmt-primary-70)' }} />
      </div>
      <div>
        <label className="percentage">{progress}%</label>
      </div>
    </div>
  );
};

export default function ProgressPerSection({
  data = {},
  getOption = () => null,
  sidebarCollapsed,
  loading,
}) {
  const { t } = useTranslation();
  const [maxWidth, setMaxWidth] = useState("100%");

  useEffect(() => {
    setMaxWidth((prev) => prev === '100%' ? '99.9%' : '100%');
  }, [sidebarCollapsed]);

  const allData = useMemo(() => {
    const all = [];
    Object.keys(data).forEach((k) => {
      const section = getOption('sections', k);
      if (section) {
        let _label = section;
        if (section && typeof section === 'object') {
          if (typeof section['subCategory is cooperative'] === 'string') {
            _label = section['subCategory is cooperative'];
          } else if (Object.values(section)[0] && typeof Object.values(section)[0] === 'string') {
            _label = Object.values(section)[0];
          }
        }
        all.push({
          label: _label,
          value: data[k],
        });
      }
    });
    return all;
  }, [data, getOption]);

  return (
    <Widget title={t('Progress per Section')} loading={loading}>
      <Style className="default-content">
        {allData.map((v, i) => (
          <div key={`sections-${i + 1}-${v.label}`} className="section">
            <div className="title">
              <Label
                text={v.label}
                maxWidth={maxWidth}
              />
            </div>
            <ProgressBar progress={v.value ? getProgress(v.value) : 0} />
          </div>
        ))}
      </Style>
    </Widget>
  )
}
